import { createSelector } from 'reselect'

const selectedCoin  = state => state.ui.selectedCoin
const coins = state => state.coins

const getSelectedCoinObj = (selectedCoin, coins) => {

  return(coins.find(c => c.id === selectedCoin))
}

export default createSelector([selectedCoin, coins], getSelectedCoinObj)



// WEBPACK FOOTER //
// ./src/selectors/selectedCoinObj.js